var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "105", height: "66", viewBox: "0 0 105 66", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Artboard"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { stroke: "#2D9F86", fill: "#FFF", d: "M53.166 39.686v-23.78l-6.554 6.496L40 15.5 54.79 1h10.092v38.686z" }),
      React.createElement("path", { d: "M102.5 62.186H2.5", stroke: "#DCF0EE", strokeWidth: "5", strokeLinecap: "square" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/static/images/number-1.svg